<template>
  <div style="margin-top: 20px; margin-bottom: 20px;">
    <h2 class="u">Добавить клиента</h2>
    <div class="sub-nav">
      <router-link class="btn btn-default btn-sm" :to="{ name: 'apartment-details', params: { apartment_id: $route.params.apartment_id } }">← Назад к Клиентам</router-link>
    </div>

    <client-add-form :apartment="+$route.params.apartment_id" @after="handleAfter" />

  </div>
</template>

<script>
import clientAddForm from '@/components/forms/client/ClientAddForm'

export default {
  name: 'client-add',
  components: { clientAddForm },
  methods: {
    handleAfter (success) {
      if (success) {
        this.$router.push({ name: 'apartment-details', params: { apartment_id: this.$route.params.apartment_id } })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// ClientAdd.vue?5ccbbfb4